import type { EventManager } from '@arkturian/audio-guide';
import type { IView } from '../IView';

/**
 * NarratorView — dropdown that lets the user pick the narration
 * persona independently of the track. Binds to #narratorSelect.
 *
 * Emits user:narrator-change with the chosen id (string). Reacts to
 * narrator:changed bus events for model→view sync (e.g. after a
 * URL param boot or after another view triggered the change).
 */
export class NarratorView implements IView {
  private _select: HTMLSelectElement | null = null;
  private _bus: EventManager | null = null;
  private _changeHandler: EventListener | null = null;

  private _onModelChanged = (payload: { name: string }): void => {
    if (!this._select) return;
    if (this._select.value !== payload.name) {
      this._select.value = payload.name;
    }
  };

  mount(root: HTMLElement): void {
    this._select = root.querySelector<HTMLSelectElement>('#narratorSelect');
  }

  bindEvents(bus: EventManager): void {
    this._bus = bus;
    if (this._select) {
      this._changeHandler = () => {
        bus.emit('user:narrator-change', { name: this._select!.value });
      };
      this._select.addEventListener('change', this._changeHandler);
    }
    bus.on('narrator:changed', this._onModelChanged);
  }

  dispose(): void {
    if (this._select && this._changeHandler) {
      this._select.removeEventListener('change', this._changeHandler);
      this._changeHandler = null;
    }
    if (this._bus) {
      this._bus.off('narrator:changed', this._onModelChanged);
      this._bus = null;
    }
  }
}
